<template>
  <div>
    <div v-if="!fetchingEdition">
      <div id="csvLinkContainer"></div>

      <v-row>
        <v-col cols="12" md="6">
          <v-card :loading="loadingExport">
            <v-card-title>
              Edition #{{ editionId }}
              <v-spacer></v-spacer>
              <v-btn icon color="green" @click="exportEditionAsExcel()">
                <v-icon>mdi-file-excel</v-icon>
              </v-btn>
              <v-btn icon @click="openDeleteDialog = true">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-simple-table>
                <template #default>
                  <tbody>
                    <tr>
                      <td>
                        <b>Commentaire</b>
                      </td>
                      <td>
                        {{ currentEdition.comment }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <b>Créée le / par</b>
                      </td>
                      <td>
                        {{ getInternationalDate(currentEdition.createdAt) }} /
                        {{ currentEdition.createdBy }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <b>Modifiée le / par</b>
                      </td>
                      <td>
                        {{ getInternationalDate(currentEdition.updatedAt) }} /
                        {{ currentEdition.updatedBy }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-card :loading="isLoading">
            <v-card-title>Cartes éditées</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <div
                id="table-card-editions-container"
                v-if="currentEdition.cards"
              >
                <base-data-table
                  :items="currentEdition.cards.data"
                  :headers="cardHeaders"
                  :server-items-length="currentEdition.cards.total"
                  :nbItemsByPage="NB_ITEMS_BY_PAGE"
                  :loading="isLoading"
                  :options.sync="options"
                  containerId="#table-card-editions-container"
                  :fixedHeaders="true"
                  class="table-cursor"
                  itemClickRouterTarget="cartes-details"
                ></base-data-table>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <LoadingDialog />
    </div>
    <delete-dialog
      :open.sync="openDeleteDialog"
      v-on:delete="triggerEditionDelete()"
    >
      <template #title> Suppression édition de cartes </template>
      Vous êtes sur le point de supprimer cette édition de cartes. Voulez-vous
      continuer ?
    </delete-dialog>
  </div>
</template>
<script>
import { defineComponent, onMounted, toRefs, ref } from "@vue/composition-api";
import { useTitle } from "@/composables/title";
import { useCardEdition } from "@/composables/cards-edition";
import router from "@/router";
import LoadingDialog from "@/components/General/LoadingDialog.vue";
import DeleteDialog from "../components/General/DeleteDialog.vue";
import { date } from "@/composables/date";
import BaseDataTable from "@/components/General/BaseDataTable.vue";

export default defineComponent({
  components: {
    LoadingDialog,
    DeleteDialog,
    BaseDataTable,
  },
  setup() {
    /* Import des API */
    const { setTitle, setIcon } = useTitle();
    const {
      editionData,
      currentEdition,
      deleteCardEdition,
      exportEdition,
      fetchCardEdition,
      fetchEditionListCards,
    } = useCardEdition();
    const { getInternationalDate } = date();

    /* Variables */
    const editionId = router.currentRoute.params.id;
    const openDeleteDialog = ref(false);
    const loadingExport = ref(false);
    const cardHeaders = [
      { text: "ID Carte", value: "id" },
      { text: "Origine", value: "cardOrigin.description" },
      { text: "Type", value: "cardType.description" },
      { text: "Mode", value: "mode.description" },
      { text: "Restrictions", value: "restrictionType.description" },
    ];
    const NB_ITEMS_BY_PAGE = 100;

    /* Méthodes */
    const triggerEditionDelete = async function () {
      openDeleteDialog.value = false;
      editionData.isLoading = true;
      await deleteCardEdition();
      router.push({ name: "card-editions" });
    };
    const exportEditionAsExcel = async function () {
      loadingExport.value = true;
      await exportEdition(editionId);
      loadingExport.value = false;
    };
    const goToCardPage = function (idCard) {
      router.push({
        name: "cartes-details",
        params: {
          id: idCard.toString(),
        },
      });
    };

    /* Cycle de vie */
    onMounted(async () => {
      setIcon("mdi-card-plus");
      setTitle(`Edition #${editionId}`);
      await fetchCardEdition(editionId);
      await fetchEditionListCards();
    });
    return {
      editionId,
      ...toRefs(editionData),
      currentEdition,
      triggerEditionDelete,
      exportEditionAsExcel,
      openDeleteDialog,
      loadingExport,
      getInternationalDate,
      cardHeaders,
      goToCardPage,
      NB_ITEMS_BY_PAGE,
    };
  },
});
</script>
